import React from "react";
import { Card, CardContent, Typography, Button, Box } from "@mui/material";
import { ArrowForward as ArrowForwardIcon, OpenInNew } from "@mui/icons-material";

interface CTACardProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    linkText: string;
    linkUrl: string;
    ariaLabel: string;
}

export default function CTACard({ icon, title, description, linkText, linkUrl, ariaLabel }: CTACardProps) {
    const handleClick = () => {
        window.open(linkUrl, "_blank", "noopener,noreferrer");
    };

    return (
        <Card
            sx={{
                flex: "1 1 45%",
                minWidth: 280,
                maxWidth: "100%",
                transition: "transform 200ms ease-in-out, box-shadow 200ms ease-in-out",
                "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: 4
                },
                cursor: "pointer"
            }}
            onClick={handleClick}
            role="article"
            tabIndex={0}
            aria-label={ariaLabel}
            onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleClick();
                }
            }}
        >
            <CardContent sx={{ p: 3, pb: 2, display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", height: "100%" }}>
                <Box sx={{ mb: 2 }}>{icon}</Box>
                <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 600 }}>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6, flex: 1 }}>
                    {description}
                </Typography>
                <Button
                    variant="outlined"
                    endIcon={<OpenInNew sx={{ fontSize: 16 }} />}
                    sx={{
                        height: "32px",
                        borderColor: "#103699",
                        color: "#103699",
                        "&:hover": {
                            borderColor: "#103699",
                            backgroundColor: "rgba(16, 54, 153, 0.04)"
                        }
                    }}
                    onClick={e => {
                        e.stopPropagation(); // Prevent double-click
                        handleClick();
                    }}
                    aria-label={ariaLabel}
                >
                    {linkText}
                </Button>
            </CardContent>
        </Card>
    );
}
